// Real image assets provided by the client (Boxly smart lockers in situ).
const B = "https://customer-assets-agu9un31.emergentagent.net/job_smart-locker-hub-5/artifacts";

export const LOCKERS = [
  `${B}/wuemra7a_ChatGPT%20Image%203%20ago%202026%2C%2017_05_25.png`,
  `${B}/g47cb5ik_ChatGPT%20Image%203%20ago%202026%2C%2016_59_42.png`,
  `${B}/l4ghda1q_ChatGPT%20Image%203%20ago%202026%2C%2016_56_36.png`,
  `${B}/c5h92d2q_ChatGPT%20Image%203%20ago%202026%2C%2016_50_25.png`,
  `${B}/w0uhuq37_ChatGPT%20Image%203%20ago%202026%2C%2016_35_35.png`,
];

export const IMG = {
  hero: LOCKERS[0],
  about: LOCKERS[4],
  solution: LOCKERS[2],
  gallery: [LOCKERS[1], LOCKERS[3]],
  // Real in-context photos (by filename)
  consegna: `${B}/qkeh6c4m_CONSEGNA.png`,
  dashboard: `${B}/f6xxec6c_DASHBOARD.png`,
  installazione: `${B}/fby9ory9_INSTALLAZIONE.png`,
  condomini: `${B}/1my6rjc8_CONDOMINI%20E%20RESIDENCE.png`,
  aziendali: `${B}/0l4cf42f_COMPLESSI%20AZIENDALI.png`,
  nuoviSviluppi: `${B}/fircqw76_NUOVI%20SVILUPPI.png`,
};

// Case-study images mapped by index to i18n.cases.cards[]
// [0] Condomini & Residence — [1] Nuovi sviluppi — [2] Complessi aziendali
export const CASE_IMAGES = [
  `${B}/1my6rjc8_CONDOMINI%20E%20RESIDENCE.png`,
  `${B}/fircqw76_NUOVI%20SVILUPPI.png`,
  `${B}/0l4cf42f_COMPLESSI%20AZIENDALI.png`,
];

// Product range shots (white background) — mapped in the same order as the product cards.
export const PRODUCTS = [
  `${B}/rbw678d0_locker-s.png`,               // Smart Locker S
  `${B}/rr1u34nu_locker-m.png`,               // Smart Locker M
  `${B}/se23um6x_locker-L.png`,               // Smart Locker L
  `${B}/pl4evthg_locker-xl.png`,              // Smart Locker XL
  `${B}/5c13tk2i_locker-indoor.png`,          // Locker Indoor
  `${B}/5iqn1s20_locker-outdoor.png`,         // Locker Outdoor
  `${B}/mlxjshn3_locker-refrigerati.png`,     // Locker Refrigerati
  `${B}/c0i0ftxe_locker%20aziendale.png`,     // Locker Aziendali
  `${B}/8lc8upo7_locker%20condominiale.png`,  // Locker Condominiali
  `${B}/fsw7aj5u_locker-personalizzato.png`,  // Locker Personalizzati
];
